module.exports = __webpack_public_path__ + "static/media/resume-en.8e22fd9b.png";